/**
 * TakerFooter — shared footer for all standalone taker pages.
 * Pair with TakerNav via TakerShell.
 */

import { PolicyLinks } from './PolicyLinks';

export default function TakerFooter({ label }: { label?: string }) {
  return (
    <footer style={{
      textAlign: 'center', padding: '20px 24px',
      color: '#9ca3af', fontSize: 12, borderTop: '1px solid #e8e3de',
      background: '#fff',
    }}>
      &copy; {new Date().getFullYear()} The Successful Bookkeeper
      {label && <>&nbsp;&middot;&nbsp;{label}</>}
      <span aria-hidden="true">&nbsp;&middot;&nbsp;</span>
      <PolicyLinks />
    </footer>
  );
}
